<!--
    描述：雇方主评价
    日期：2022/9/26
    创建人：李家宝
-->
<template>
  <div>
    <el-empty description="暂无数据" v-if="tableData.length == 0"></el-empty>
    <template v-else>
      <div>
        当前项目雇主方评价
        <span style="color: #0000FF">{{ tableData.length }}</span
        >次
      </div>
      <div class="mt10">
        <el-table
          :data="tableData"
          highlight-current-row
          row-key="id"
          border
          ref="table"
          style="width: 100%"
        >
          <el-table-column
            label="发表时间"
            prop="evaluateDate"
            align="center"
            width="161"
          ></el-table-column>
          <el-table-column
            label="评价事项"
            prop="evaluateItem"
            show-overflow-tooltip
            min-width="121"
          >
          </el-table-column>
          <el-table-column
            label="被评价人"
            prop="beJudger"
            show-overflow-tooltip
            min-width="121"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.beJudger }}</span>
              <span>（{{ scope.row.beJudgerPhone }}）</span>
            </template>
          </el-table-column>
          <el-table-column
            label="综合评分"
            prop="compositeScore"
            show-overflow-tooltip
            align="center"
            min-width="121"
          >
            <template slot-scope="scope">
              {{ scope.row.compositeScore }}分
            </template>
          </el-table-column>
          <el-table-column
            label="评价结果"
            align="center"
            prop="evaluateResult"
            show-overflow-tooltip
            min-width="121"
          >
            <template slot-scope="scope">
              {{ scope.row.evaluateResult == 0 ? "差评" : "好评" }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="100">
            <template slot-scope="scope">
              <el-button size="mini" @click="viewEvaluation(scope.row)"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="w-table-footer">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageList"
          :page-size="pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
    </template>
    <!--弹窗-->
    <el-dialog
      :visible.sync="auditShow"
      width="50%"
      center
      title="评价服务"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <div class="dialog-box">
        <div style="text-align: center">
          <span>{{ currentRowData.sname }}</span>
          <span style="margin: 0 20px"></span>
          <span>{{ currentRowData.evaluateDate }}</span>
        </div>
        <div class="dialog-box-item">
          <div class="dialog-box-left">
            <div class="mark">中标人</div>
            <img
              class="avatar"
              :src="imgUrl + currentRowData.bidderAvatar"
              alt=""
            />
            <div class="mt5">
              {{ currentRowData.bidderName }}（{{
                currentRowData.bidderPhone
              }}）
            </div>
            <div class="mt5">{{ currentRowData.bidderAddress }}</div>
            <div class="mt20 mb50">
              <span class="mr20"
                >综合评分：{{ currentRowData.compositeScore }}分</span
              >
              <span>好评率：{{ currentRowData.praiseRate }}%</span>
            </div>
          </div>
          <div class="dialog-box-right">
            <div class="box-right-item">
              <div
                class="flex mr55"
                v-for="(item, index) in currentRowData.evaluationInfo"
                :key="index"
              >
                <span class="mr10 name">{{ item.evalItemName }}</span>
                <el-rate
                  :value="item.singleScore"
                  disabled
                  show-score
                  :score-template="
                    item.singleScore == null ? '0分' : item.singleScore + '分'
                  "
                ></el-rate>
              </div>
            </div>
            <div class="mt20">
              <el-row>
                <el-col :span="4">
                  评价晒单:
                </el-col>
                <el-col :span="20">
                  <div class="area">
                    {{ currentRowData.content }}
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getEvaluatePageList,
  queryEvaluatePageInfo
} from "api/modules/projectManagement";
import VUE_CONFIG from "../../../../../vue.config";
export default {
  name: "employer-evaluation",
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    imgUrl() {
      let uploadUrl = "";
      if (process.env.VUE_APP_UPLOAD_URL == "/uploadApi") {
        uploadUrl = VUE_CONFIG.devServer.proxy["/uploadApi"].target;
      } else {
        uploadUrl = process.env.VUE_APP_UPLOAD_URL;
      }
      return uploadUrl;
    }
  },
  data() {
    return {
      currentPage: 1, // 当前页码
      pageList: [10, 20, 50, 100], // 显示条数数组
      pageSize: 10, // 当前显示条数
      total: 0, // 当前总条数
      tableData: [],
      auditShow: false, // 审核弹窗的显隐
      btnLoading: false,
      currentRowData: {}, // 当前行数据
      value1: 3,
      value2: 4.5
    };
  },
  methods: {
    // 获取列表数据
    getEvaluatePageList() {
      getEvaluatePageList({
        subProjectId: this.rowData.businessId,
        current: this.currentPage,
        size: this.pageSize
      }).then(res => {
        if (res.operationCode == 1) {
          this.tableData = res.data.records;
          this.currentPage = parseInt(res.data.current);
          this.total = parseInt(res.data.total);
          this.pageSize = parseInt(res.data.size);
        }
      });
    },

    // 查看评价
    viewEvaluation(currentData) {
      queryEvaluatePageInfo({
        subProjectId: currentData.subProjectId
      }).then(res => {
        if (res.operationCode == 1) {
          this.auditShow = true;
          this.currentRowData = res.data;
        }
      });
    },

    // close 审查弹框
    closeDialog() {
      this.auditShow = false;
    },
    // 切换显示条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.getEvaluatePageList();
    },

    //切换当前页码
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getEvaluatePageList();
    }
  },

  created() {},

  mounted() {}
};
</script>

<style scoped lang="less">
.w-table-footer {
  display: flex;
  justify-content: center;
  margin: 20px;
}
/deep/.el-dialog--center .el-dialog__body {
  padding: 25px 0;
}
.el-button {
  background-color: #199ed8;
  color: white;
}

.dialog-box-item {
  display: flex;
  margin-top: 20px;
  border-top: 1px solid #cccccc;
  border-bottom: 1px solid #cccccc;
  .dialog-box-left {
    width: 400px;
    text-align: center;
    border-right: 1px solid #cccccc;
    .mark {
      width: 60px;
      height: 25px;
      text-align: center;
      line-height: 25px;
      color: white;
      background-color: #ff9900;
    }
    .avatar {
      width: 60px;
      height: 60px;
      border-radius: 50%;
    }
  }
  .dialog-box-right {
    padding: 50px 20px 20px 20px;
    .box-right-item {
      display: flex;
      flex-wrap: wrap;
      .name {
        display: inline-block;
        width: 120px;
      }
    }
    .area {
      width: 500px;
    }
  }
}
</style>
